import React, { useState } from 'react'

/** ไอคอนซ้ายการ์ดประวัติ: สำเร็จ(เขียว), ไม่อนุมัติ(แดง), รอผล(นาฬิกา), ข้อมูล(น้ำเงิน i) */
export type HistoryCardLeftIcon = 'success' | 'reject' | 'pending' | 'info'

export type HistoryDetailRow = {
  label: string
  value: string
  tone?: 'default' | 'positive' | 'negative' | 'muted'
}

const LEFT_ICON_MAP: Record<HistoryCardLeftIcon, { className: string; icon: string }> = {
  success: { className: 'htd-hist-card__status--success', icon: 'fa fa-check' },
  reject: { className: 'htd-hist-card__status--reject', icon: 'fa fa-times' },
  pending: { className: 'htd-hist-card__status--pending', icon: 'fa fa-clock' },
  info: { className: 'htd-hist-card__status--info', icon: 'fas fa-info-circle' },
}

const TONE_CLASS: Record<NonNullable<HistoryDetailRow['tone']>, string> = {
  default: '',
  positive: 'htd-hist-detail__value--positive',
  negative: 'htd-hist-detail__value--negative',
  muted: 'htd-hist-detail__value--muted',
}

interface HistoryCollapseCardProps {
  id: string
  leftIcon: HistoryCardLeftIcon
  header: React.ReactNode
  refId: string
  rows: HistoryDetailRow[]
  onCopyRef?: () => void
  actionLabel?: string
  onAction?: () => void
  secondaryActionLabel?: string
  onSecondaryAction?: () => void
  dangerActionLabel?: string
  onDangerAction?: () => void
}

/** การ์ด collapse ใช้ในประวัติฝาก/ถอน/เครดิต/เล่นพนัน */
export const HistoryCollapseCard: React.FC<HistoryCollapseCardProps> = ({
  id,
  leftIcon,
  header,
  refId,
  rows,
  onCopyRef,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
  dangerActionLabel,
  onDangerAction,
}) => {
  const [open, setOpen] = useState(false)
  const left = LEFT_ICON_MAP[leftIcon]
  return (
    <div className="htd-hist-card">
      <button
        type="button"
        className="htd-hist-card__toggle"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-controls={`collapse-${id}`}
      >
        <div className={`htd-hist-card__status ${left.className}`} aria-hidden>
          <i className={left.icon} />
        </div>
        <div className="htd-hist-card__header">{header}</div>
        <div className="htd-hist-card__expand" aria-hidden>
          {open ? '-' : '+'}
        </div>
      </button>
      {open && (
        <div className="htd-hist-card__body" id={`collapse-${id}`}>
          <div className="htd-hist-ref">
            <div>
              <span className="htd-hist-ref__label">เลขที่อ้างอิง</span>
              <span className="htd-hist-ref__value" title={refId}>
                {refId}
              </span>
            </div>
            <div className="htd-hist-ref__actions">
              {actionLabel && onAction && (
                <button
                  type="button"
                  className="htd-hist-ref__btn htd-hist-ref__btn--primary"
                  onClick={(e) => {
                    e.stopPropagation()
                    onAction()
                  }}
                >
                  <i className="fas fa-search me-1" /> {actionLabel}
                </button>
              )}
              {secondaryActionLabel && onSecondaryAction && (
                <button
                  type="button"
                  className="htd-hist-ref__btn htd-hist-ref__btn--accent"
                  onClick={(e) => {
                    e.stopPropagation()
                    onSecondaryAction()
                  }}
                >
                  <i className="fas fa-upload me-1" /> {secondaryActionLabel}
                </button>
              )}
              {dangerActionLabel && onDangerAction && (
                <button
                  type="button"
                  className="htd-hist-ref__btn htd-hist-ref__btn--ghost"
                  style={{ color: '#f87171' }}
                  onClick={(e) => {
                    e.stopPropagation()
                    onDangerAction()
                  }}
                >
                  <i className="fas fa-times me-1" /> {dangerActionLabel}
                </button>
              )}
              <button
                type="button"
                className="htd-hist-ref__btn htd-hist-ref__btn--ghost"
                onClick={(e) => {
                  e.stopPropagation()
                  onCopyRef?.()
                }}
              >
                <i className="fas fa-copy me-1" /> คัดลอก
              </button>
            </div>
          </div>
          <div>
            <h5 className="htd-hist-detail__title">รายละเอียด</h5>
            <dl className="htd-hist-detail__list">
              {rows.map((row, index) => {
                const tone = row.tone || 'default'
                const isLongValue = row.value.length > 72 || row.value.includes('\n')
                return (
                  <div key={`${row.label}-${index}`} className="htd-hist-detail__item">
                    <dt className="htd-hist-detail__label">{row.label}</dt>
                    <dd
                      className={[
                        'htd-hist-detail__value',
                        TONE_CLASS[tone],
                        isLongValue ? 'htd-hist-detail__value--long' : '',
                      ]
                        .filter(Boolean)
                        .join(' ')}
                    >
                      {row.value}
                    </dd>
                  </div>
                )
              })}
            </dl>
          </div>
        </div>
      )}
    </div>
  )
}
